/** @module */

/**
 * @enum {string}
 * @includevals
 */
export const commentTypes = {
    comment: 'comment',
};